<ng-container *ngIf="myTeacher && showProInfo; else elseTemplate">
  <!-- Langue enseignée -->
  <div class="languages-wrap">
    <div class="teaching-row">
        <b translate>teacher.account.teaching-lbl</b> : <span translate>{{myTeacher.teach_language.code}}</span>
    </div>
    
    <!-- Langues parlées -->
    <div class="speaking-row">
          <b translate>teacher.account.speaking-lbl</b> :
          <span class="speaking_language" *ngFor="let language of myTeacher.languages" translate>
            {{ language.label }}
          </span>
    </div>
  </div>

  <!-- Description -->
  <div class="row">
    <b translate>teacher.account.self-intro-lbl</b>:
    <a (click)="showInfo = true">
      <i class="material-icons helpicon">help</i>
    </a>
    <div class="popup-overlay-flex" *ngIf="showInfo">
    <ng-container *ngIf="showInfo">
      <div class="border-info-flex" >
        <i class="material-icons help-closeicon" (click)="showInfo = false">close</i>
        <div class="summary">
          <p class="help-title" translate>teacher.account.pro-info.self-introduction</p>
          <p translate>teacher.account.pro-info.intro-description</p>
          <p translate>teacher.account.pro-info.help-offer</p>          
        </div>
      </div>
    </ng-container>
    </div>
  </div>
  <ng-container *ngIf="myTeacher.teach_language">
    <ng-container *ngIf="myTeacher.teach_language.label !== 'French' ">
      <div class="desclang-btn-wrapper">
        <mat-button-toggle-group [(ngModel)]="version">
          <mat-button-toggle class="toggle-french" [value]=true>
            <b translate>teacher.account.french-btn</b>
          </mat-button-toggle>
          <mat-button-toggle class="toggle-native" [value]=false>
            <b translate>teacher.account.english-btn</b>              
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </ng-container>
  </ng-container>
   <div *ngIf="version">{{ myTeacher.description_fr }}</div>
   <div *ngIf="!version">{{ myTeacher.description_vo }}</div>
    <div class="usefuldocs-wrapper">
      <b translate>teacher.account.pro-info.useful-resources</b>
      <a href="https://teamup.lingueo.com/fr/" target="_blank" translate>teacher.account.pro-info.charter-fr</a>
      <a href="https://teamup.lingueo.com/en/" target="_blank" translate>teacher.account.pro-info.charter-en</a>
      <a href="{{myTeacher.service_contract}}" target="_blank" translate>teacher.account.pro-info.contract</a>      
    </div>
</ng-container>
<ng-template #elseTemplate>
  <div class="row center loading pageload-message">
    <b translate>teacher.account.pro-info-loading</b>
  </div>
</ng-template>

